module.exports = __webpack_public_path__ + "images/mortgage.3adf03ce64e55983b6dbbf70ee00fdcf.svg";